<ion-alert
  cssClass="customConfirmationDialog"
  [trigger]="trigger"
  [header]="header ? (header | translate) : undefined"
  [message]="message ? (message | translate) : undefined"
  [buttons]="confirmationButtons"
  (didDismiss)="onConfirmationAlertDismiss($event)"
></ion-alert>